import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Heading } from '@leroy-merlin-br/backyard-react-ui'

const stepTitleStyles =
  ({ theme }) => css`
    label: step__title;

    font-size: ${theme.typography.headings.mega.fontSize};
    font-weight: ${theme.font.weight.semibold};
    text-align: center;
    width: 260px;
    margin: 0px auto ${theme.spacings.giga};

    ${theme.media.mega} {
      width: 100%;
    }
  `

export const StepTitle = styled(Heading)(stepTitleStyles)

const stepSubTitleStyles =
  ({ theme }) => css`
    label: step__sub-title;

    text-align: center;
    width: 260px;

    ${theme.media.mega} {
      width: 100%;
    }
  `

export const StepSubTitle = styled('h3')(stepSubTitleStyles)

const ilustrationWrapperStyles =
  ({ theme }) => css`
    label: ilustration-wrapper;

    display: flex;
    justify-content: center;
    margin-bottom: ${theme.spacings.giga};

    svg {
      width: 200px;
      height: 200px;
    }

    ${theme.media.mega} {
      svg {
        width: 230px;
        height: 230px;
      }
    }
  `

export const IlustrationWrapper = styled('div')(ilustrationWrapperStyles)

const buttonGridStyles = ({ theme }) => css`
  label: button-grid;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${theme.spacings.mega};
`
export const ButtonGrid = styled('div')(buttonGridStyles)

const buttonWrapperStyles = ({ theme }) => css`
  label: button-wrapper;

  margin-top: ${theme.spacings.mega};
`

export const ButtonWrapper = styled('div')(buttonWrapperStyles)

const buttonGridErrorStyles =
  ({ theme }) => css`
    label: button-grid--error;

    position: absolute;
    bottom: 0;
    width: 100%;
    font-size: ${theme.typography.subHeadings.kilo.fontSize};
    text-align: center;
    color: ${theme.colors.r500};
  `

export const ButtonGridError = styled('span')(buttonGridErrorStyles)

const fieldGridStyles = ({ theme }) => css`
  label: field-grid;

  display: grid;
  align-items: center;

  grid-template-columns: 1fr auto;
  grid-row-gap: ${theme.spacings.bit};
  grid-column-gap: ${theme.spacings.kilo};
`

export const FieldGrid = styled('div')(fieldGridStyles)
